import type { GeneralFilter } from '~/shared/data-contract/filter';
import { learningOpportunitiesStatisticsSchema } from '~/shared/data-contract/learning-opportunities';
import type { Pathname } from '~/shared/http-fetcher/http-fetcher';

const pathname: Pathname = `/learning-opportunities`;
const filterPathname: Pathname = `/learning-opportunities/filter`;
const statisticsPathname: Pathname = `/learning-opportunities/statistics`;

export const learningOpportunityKeys = {
    all: [pathname] as const,
    allStatistics: () => [statisticsPathname] as const,
    completion: (id: string) => [pathname, id, 'completion'] as const,
    details: () => [pathname, 'get'] as const,
    featuredOptions: (id: string) => [`/featured-opportunities/${id}/options`] as const,
    filter: () => [filterPathname] as const,
    options: () => [`/learning-opportunities/options`, 'GET'] as const,
    optionsForId: (id: string) => [`/learning-opportunities/${id}/options`, 'GET', id] as const,
    statistics: (filter?: GeneralFilter) =>
        [
            ...learningOpportunityKeys.allStatistics(),
            'postJson',
            learningOpportunitiesStatisticsSchema,
            filter,
        ] as const,
} as const;

export const learningOpportunityPathnames = {
    detail: (id: string): Pathname => `${pathname}/${id}`,
    filter: filterPathname,
    pathname,
    statistics: statisticsPathname,
} as const;
